// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"51f65661","496":"04fce8b8","513":"b8adfec1","703":"5a9d7ba5"}[chunkId] + ".chunk.js";
};